/**
 * @class
 * @extends mkE.Base
 * @typedef {{id:String|null,className:String|null,els:Object|Array|null}} T.CallToAction.Par
 */
T.CallToAction = Class(
	/**
	 * @lends {T.CallToAction#}
	 */
	{
		/** @type {T.CallToAction.Par} */
		par: null,

		active: false,

		/** @param {T.CallToAction.Par} par */
		__construct: function ( par ) {
			this.par = par;
			this.node = mkE({
				tag: 'div',
				id: par.id || '',
				className: 't-cta',
				els: [
					this.wrapper = mkE({
						tag: 'div',
						className: 'wrapper',
						els: [
							this.content = mkE({
								tag: 'div',
								className: 'container'
							})
						]
					})
				]
			});
			if( par.className ) {
				addClassName(this.node, par.className);
			}
			if( par.els ) {
				this.setContent(par.els);
			}

			this.hide();
		},

		setContent( els ) {
			mkE.appendTypeElement(this.content, els);
		},

		show() {
			this.node.style.bottom = '0';
			this.wrapper.style.bottom = '0';
			this.active = true;
		},

		hide() {
			this.node.style.bottom = '';
			this.wrapper.style.bottom = '';
			this.active = false;
		}

	},
	mkE.Base
);